<script>
import gaFilterComponentMixin from '@mixins/gaFilterComponentMixin';
import gaFilterAutocompleteMixin from '@mixins/gaFilterAutocompleteMixin';
import GaBaseExpandedFilter from '@components/v2/filter/sidebarFilters/parts/GaBaseExpandedFilter.vue';
import GaBaseFoldedFilter from '@components/v2/filter/sidebarFilters/parts/GaBaseFoldedFilter.vue';
import Checkbox from 'primevue/checkbox';
import permissionsMixinComputed from '@mixins/permissionsMixinComputed';
import AkInputText from '@components/v2/input/AkInputText.vue';
import accommodationService from '@services/accommodationService';
import accommodationAutocompleteMixin from '@mixins/autocomplete/accommodationAutocompleteMixin';
import AkShimmer from '@components/v2/general/AkShimmer.vue';
import GaFilterBaseAutocomplete from '@components/v2/filter/sidebarFilters/parts/GaFilterBaseAutocomplete.vue';

export default {
  name: 'GaFilterAccommodation',
  components: {GaFilterBaseAutocomplete, AkShimmer, AkInputText, Checkbox, GaBaseFoldedFilter, GaBaseExpandedFilter},
  mixins: [gaFilterComponentMixin, gaFilterAutocompleteMixin, permissionsMixinComputed, accommodationAutocompleteMixin],
  data() {
    return {
      searchFilter: {
        name: null,
      },
    };
  },
  methods: {
    init() {
      if (!this.isGasGav && !this.isAdmin) {
        console.log('Autocomplete accommmodation');
        return this.autocompleteAccommodation({}).then((data) => {
          this.options = data;
          this.optionsLoaded = true;
        });
      }
    },
    removeOption(option) {
      if (!this.isGasGav && !this.isAdmin) return;
      this.options = this.options.filter((o) => o.id !== option.id);
      this.$refs.autocomplete.removeSuggestion(option);
    },
  },
  watch: {
    isExpanded(newVal) {
      if (newVal) {
        this.searchFilter.name = null;
        if (this.isGasGav || this.isAdmin) {
          this.options = [];
          this.currentFilter.value.forEach((value, index) => {
            this.options.push({id: value, display: this.currentValue.labels[index]});
          });

          this.$nextTick(() => {
            this.$refs.autocomplete.resetSuggestions();
            this.$refs.autocomplete.initSelectedSuggestions(this.options);
          });
        }
      }
    },
  },
};
</script>

<template>
  <template v-if="isVisible">
    <GaBaseFoldedFilter
      v-if="!isExpanded"
      title="Logement"
      @expand="onClick"
      :icon="hasIcon ? 'ga-home' : null"
      :subtitle="subtitle"
      :nb-selected="nbSelected" />
    <GaBaseExpandedFilter
      v-else
      title="Logement"
      :nb-selected="nbSelected"
      :can-go-back="canGoBack"
      @apply="apply"
      @reset="reset"
      @back="back">
      <GaFilterBaseAutocomplete
        v-if="isGasGav || isAdmin"
        ref="autocomplete"
        :filter="searchFilter"
        filter-property="name"
        :search-method="autocompleteAccommodation"
        @option-select="checkOption"
        placeholder="Rechercher un logement" />

      <div class="flex flex-col gap-1 px-3.5 py-3">
        <div v-if="!isGasGav && !this.isAdmin" class="px-5 flex items-center relative pb-2">
          <AkInputText
            inputClass="!bg-transparent !border-2 !border-grey-100 !rounded-full !pl-[40px] !pr-6"
            v-model="optionFilter"
            placeholder="Rechercher un logement" />
          <i class="ga-icon ga-search text-3xl absolute left-8 grey-900" />
        </div>
        <div v-for="option in filteredOptions" :key="option.id" class="py-1.5 px-3 w-full">
          <label class="gap-3 flex px-2 py-1 items-center cursor-pointer">
            <checkbox
              v-model="currentFilter.value"
              @update:model-value="removeOption(option)"
              :value="option.id"
              class="[&_.p-checkbox-box]:!border-grey [&_.p-checkbox-box]:border [&_.p-checkbox-box]:rounded-6"
              :class="{
                '[&_.p-checkbox-box]:!bg-primary [&_.p-checkbox-box]:border-0': currentFilter.value.includes(option.id),
              }" />
            <span class="font-medium text-grey-900 select-none">
              {{ option.display }}
            </span>
          </label>
        </div>
        <span class="text-center text-grey-400 py-2" v-if="!filteredOptions.length && !isGasGav">Aucun résultat</span>
      </div>
    </GaBaseExpandedFilter>
  </template>
</template>

<style scoped></style>
